import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  button: {
    //borderRadius: 6,
    //width: 25,
   // height: 16,
    paddingBottom:5,
  },
}));
export default useStyles;
